import { render, staticRenderFns } from "./AuthScreen.vue?vue&type=template&id=d7b1b534&"
import script from "./AuthScreen.vue?vue&type=script&lang=js&"
export * from "./AuthScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports